/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type UserUnblockInput = {
    readonly effectiveDateTime?: any | null;
    readonly userId: string;
    readonly clientMutationId?: string | null;
};
export type UserUnblockMutation_MutationVariables = {
    readonly input: UserUnblockInput;
};
export type UserUnblockMutation_MutationResponse = {
    readonly userUnblock: ({
        readonly clientMutationId: string | null;
    }) | null;
};
export type UserUnblockMutation_Mutation = {
    readonly response: UserUnblockMutation_MutationResponse;
    readonly variables: UserUnblockMutation_MutationVariables;
};



/*
mutation UserUnblockMutation_Mutation(
  $input: UserUnblockInput!
) {
  userUnblock(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UserUnblockInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "userUnblock",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "UserUnblockInput!"
      }
    ],
    "concreteType": "UserUnblockPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "UserUnblockMutation_Mutation",
  "id": null,
  "text": "mutation UserUnblockMutation_Mutation(\n  $input: UserUnblockInput!\n) {\n  userUnblock(input: $input) {\n    clientMutationId\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "UserUnblockMutation_Mutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "UserUnblockMutation_Mutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
(node as any).hash = 'ac561a1557495a16eaa68069581e9291';
export default node;
